import clx from 'classnames';
import React from 'react';
import styled from 'styled-components';

export interface IInputLikeWrapperProps {
  children: React.ReactNode;
  left?: boolean;
  right?: boolean;
  grayBackground?: boolean;
  noBorder?: boolean;
}

/**
 * Wrapper che simula graficamente i bordi di un input.
 */
export function InputLikeWrapper(props: IInputLikeWrapperProps) {
  const { children, left, right, grayBackground, noBorder } = props;
  return (
    <InputLikeTextStyle
      className={clx({
        'input-like-text__left': left,
        'input-like-text__right': right,
        'remove-border': noBorder,
        'gray-background': grayBackground,
      })}
    >
      {children}
    </InputLikeTextStyle>
  );
}

const InputLikeTextStyle = styled.div`
  position: relative;
  display: block;
  width: auto;
  min-width: 0;
  padding: 4px 11px;
  font-size: ${props => props.theme.fontSize}px;
  line-height: ${props => props.theme.lineHeight};
  background-image: none;
  border-width: 1px;
  border-style: solid;
  border-color: ${props => props.theme.colorBorder};
  border-radius: ${props => props.theme.borderRadius}px;
  transition: all 0.2s;
  overflow-y: auto;

  background-color: ${props => props.theme.colorBgContainer};

  &.gray-background {
    background-color: ${props => props.theme.colorBgContainerDisabled};
  }

  &.input-like-text__left {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  &.input-like-text__right {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  /* &.input-like-text__sm {
    padding: 0 7px;
    border-radius: ${props => props.theme.borderRadiusSM}px;
  } */
  &.remove-border {
    border-color: transparent;
  }
  > .ant-typography {
    margin: 0;
    padding: 0;
  }
`;
